<app-topbar></app-topbar>
<div class="content-container">
  <app-navbar></app-navbar>
  <div class="container-fluid">
    <h2 class="my-3">Editar Perfil de Usuario</h2>
    <h4 class="border-bottom pb-2 mt-2">Información Personal</h4>
    <form (ngSubmit)="guardarUsuario()">
      <div class="mb-2">
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="nombreCompleto" class="form-label"
              >Nombre Completo</label
            >
            <input
              type="text"
              class="form-control"
              id="nombreCompleto"
              name="nombreCompleto"
              [(ngModel)]="usuario.nombreCompleto"
              [ngClass]="{ 'is-invalid': errores['nombreCompleto'] }"
              required
            />
            <div class="invalid-feedback" *ngIf="errores['nombreCompleto']">
              {{ errores["nombreCompleto"] }}
            </div>
          </div>
          <div class="col-md-6">
            <label for="usuario" class="form-label">Nombre de Usuario</label>
            <input
              type="text"
              class="form-control"
              id="usuario"
              name="usuario"
              [(ngModel)]="usuario.usuario"
              disabled
              readonly
            />
            <small class="text-muted"
              >El nombre de usuario no puede ser modificado.</small
            >
          </div>
        </div>
      </div>
      <div class="mb-2" *ngIf="roles.length > 0">
        <h4 class="border-bottom pb-2">Roles de Usuario</h4>
        <div class="table-responsive">
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>Roles Asignados</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rol of rolesUsuario">
                <td>{{ rol.replace("ROLE_", "") }}</td>
              </tr>
              <tr *ngIf="!rolesUsuario.length">
                <td class="text-center">No tiene roles asignados</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="mb-4">
        <h4
          class="border-bottom pb-2 d-flex justify-content-between align-items-center"
        >
          <span>Contraseña</span>
          <button
            type="button"
            class="btn btn-sm btn-outline-secondary"
            (click)="toggleCambiarPassword()"
          >
            {{ cambiarPassword ? "Cancelar" : "Cambiar Contraseña" }}
          </button>
        </h4>

        <div *ngIf="cambiarPassword" class="row">
          <div class="col-md-4 mb-3">
            <label for="nuevaPassword" class="form-label"
              >Nueva Contraseña</label
            >
            <input
              type="password"
              class="form-control"
              id="nuevaPassword"
              name="nuevaPassword"
              [(ngModel)]="usuario.nuevaPassword"
              [ngClass]="{ 'is-invalid': errores['nuevaPassword'] }"
            />
            <div class="invalid-feedback" *ngIf="errores['nuevaPassword']">
              {{ errores["nuevaPassword"] }}
            </div>
          </div>
          <div class="col-md-4 mb-3">
            <label for="confirmarPassword" class="form-label"
              >Confirmar Contraseña</label
            >
            <input
              type="password"
              class="form-control"
              id="confirmarPassword"
              name="confirmarPassword"
              [(ngModel)]="usuario.confirmarPassword"
              [ngClass]="{ 'is-invalid': errores['confirmarPassword'] }"
            />
            <div class="invalid-feedback" *ngIf="errores['confirmarPassword']">
              {{ errores["confirmarPassword"] }}
            </div>
          </div>
        </div>
        <div *ngIf="!cambiarPassword" class="text-muted">
          Seleccione "Cambiar Contraseña" si desea actualizar su contraseña.
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <button type="submit" class="btn btn-primary btn-lg">
          Guardar Cambios
        </button>
      </div>
    </form>
  </div>
</div>
